import { ChangeDetectorRef, Injectable, isDevMode } from '@angular/core';
import dayjs from '../_utils/dayjs.config';
import { GeneralService } from './general.service';
import { Ticket, TicketBase } from '../_interfaces/ticket';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';
import { SaveService } from './save.service';
import { TicketEmployee } from './tickets/ticket.service';
import {TicketZeit} from "../_interfaces/TicketTime";
import { Platform } from '@ionic/angular';
import { HttpService } from './http.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Task } from '../_interfaces/Task';
import { EditArt } from '../_interfaces/EditArt';
import { AuthService, ROLE } from './auth.service';
import { LocalNotificationService } from './notifications/local-notification.service';


export interface TimeTicketBundle{
  ticket: Ticket,
  time: TicketZeit,
  workspaceId?: number,
  taskId?: number,
  taskDescription?: string
}

@Injectable({
  providedIn: 'root'
})
export class ZeitenService {

  private _newTimeList: BehaviorSubject<any> = new BehaviorSubject<any>(null)
  private timerSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null)

  public timeTickett: TimeTicketBundle [] = []

  private _activeTimeFilter : BehaviorSubject<EditArt> = new BehaviorSubject<EditArt>(null);
  public get activeTimeFilter() : Observable<EditArt> {
    return this._activeTimeFilter.asObservable();
  }
  public setActiveTimeFilter(value: EditArt){
    this._activeTimeFilter.next(value)
  }

  
  // private _activeWorkstepTime : TimeTicketBundle;
  // public get activeWorkstepTime() : TimeTicketBundle {
  //   return this._activeWorkstepTime;
  // }
  // public set activeWorkstepTime(v : TimeTicketBundle) {
  //   this._activeWorkstepTime = v;
  // }

  
  private _activePersonalTime : TimeTicketBundle[];
  public get activePersonalTimes() : TimeTicketBundle[] {
    return this._activePersonalTime;
  }
  public set activePersonalTimes(v : TimeTicketBundle[]) {
    this._activePersonalTime = v;
  }

  
  private _activeExternalTimes : TimeTicketBundle[];
  public get activeExternalTimes() : TimeTicketBundle[] {
    return this._activeExternalTimes;
  }
  public set activeExternalTimes(v : TimeTicketBundle[]) {
    this._activeExternalTimes = v;
  }
  
  
  

  public get activeTimeFilterValue(){
    return this._activeTimeFilter.value
  }
  
  private _timeOverviewHidden : boolean = false;
  public get timeOverviewHidden() : boolean {
    return this._timeOverviewHidden;
  }
  public set timeOverviewHidden(v : boolean) {
    if(this.platform.is("capacitor")){
      this._timeOverviewHidden = v;
      return
    }
    this._timeOverviewHidden = false
  }

  constructor(
    private general: GeneralService,
    private saveSrv: SaveService.Ticket,
    private ticketSrv: TicketEmployee.TicketService,
    private platform: Platform,
    private http: HttpService,
    private authSrv: AuthService,
    private localNotification: LocalNotificationService
  ) {
    this.startTimer()
    this.ticketSrv.newWorkstepSelected.subscribe((id: number)=>{
      if(id == null) return
      this._activeTimeFilter.next({id: 0, description: "Ticketzeiten"})
    })

    //Jede Minute die Aktiven Zeiten holen
    if(this.authSrv.isDemoMode) return 
    if(this.authSrv.getUser().role?.includes("employee")) setInterval(async() => {
      if(this.authSrv.getUser().role?.includes("employee")) await this.getAllActiveTimes()
    }, 60000);
    
    // this.ticketSrv.newWorkstepSelected.subscribe(id=> this.ticketSrv.runningTimeIdsByWorkstepId = this.getRunningTimeIdsByWorkstepId(id))

  }

  public async getAllActiveTimes(){
    if(!this.authSrv.getUser()) return
    const result: HttpFunctionResult<TicketZeit[]> = await this.ticketSrv.getAllActiveWorkstepTimes()
    if(!result.success) return
    this.setActiveTimes(result.data)
  }

  private startTimer(){
    setInterval(()=>this.timerSubject.next(null),1000)
  }



  /**gibt timer der auf der Ganzen Seite gleich läuft */
  public timer(): Observable<any>{
    return this.timerSubject.asObservable()
  }

  /**
   * Setzt bereits laufende Zeiten in laufende Zeiten Array 
   * @example bereits laufende Zeiten die von Server kommen
   * @param {TicketZeit[]} times Array der laufenden Zeiten 
   */
  public setActiveTimes(times: TicketZeit[]){
  
    this.timeTickett = []
    let forEchCount: number = 0
    times.forEach((time: TicketZeit)=>{
      const ticketTime = {
        ticket: {id: time.ticketId, timeFrom: time.timeFrom, description: time.ticketName},
        workspaceId: time.workstepId,
        time: time,
        taskId: time.taskId,
        taskDescription: time.taskDescription
      }
      this.timeTickett.push(ticketTime)
      forEchCount++
      if(forEchCount == times.length) this._newTimeList.next(ticketTime)
    })
    this.localNotification.checkOngoingNotifications(this.timeTickett)
  }

  /**@returns {TicketZeit} Gibt zurück ob das aktuelle Ticket auch das Ticket ist wo die Zeit gestartet wurde*/
  public isActiveTicket(workstepId: number): TicketZeit{
    let ticketArrayPos: number = this.getTicketPosition(workstepId)
    if (ticketArrayPos !== null){
      return this.timeTickett[ticketArrayPos].time
    }else{
      return null
    }
  }

  /**Gibt alle Ticketzeiten als liste Zurück*/
  public getListOfTimes(): {ticket: Ticket, time: TicketZeit, workspaceId?: number, taskId?: number, taskDescription?: string}[]{
    return this.timeTickett
  }

  /**@returns {Observable<any>} Wird getriggered wenn ein ticket angeklickt wird */
  public newTicketSelected(): Observable<any>{
    return this.general.activeTicket
  }

  /**Wird getriggered wenn Zeit extern gestartet wurde
   * @returns {Observable<any>} */
  public get newActiveTimeList(): Observable<any>{
    return this._newTimeList.asObservable()
  }

  /**
   * Startet die Ticket Zeit des übergebenen workspace
   * @param {number} workstepId id des Arbeitsschrittes
   * @param {TicketBase} ticket Ticket
   */
  public async startTicketTime(workstepId: number, ticket: TicketBase, task?: Task ): Promise<HttpFunctionResult<TimeTicketBundle>>{

    let activeTicket: Ticket = ticket ? ticket : this.general.getTicketValue().ticket
    // activeTicket.timeFrom = new Date()
    // this._externalStart.next(activeTicket)
    const result: HttpFunctionResult<any> = await this.saveSrv.saveTicketTime({timeFrom: new Date(), isNewTime: true, note: ""}, activeTicket, workstepId, task ? task.id : 0)
    if(!result.success) return {success: false}
    
    const newTime: {ticket: Ticket, time: TicketZeit, workspaceId?: number, taskId?: number, taskDescription?: string } = {
      ticket: activeTicket,
      workspaceId: workstepId ? workstepId : this.ticketSrv.activeWorkstepId,
      time: {
        id: result.data.id,
        timeFrom:  new Date(),
        workstepId: workstepId ? workstepId : this.ticketSrv.activeWorkstepId,
        employeeId: +this.authSrv.getUser().id
      },
      taskId: task ? task.id : 0,
      taskDescription: task ? task.description : null
    }

    this.timeTickett.push(newTime)
    // this._externalStart.next(newTime)
    this.setActiveTimeFilter(this.activeTimeFilterValue)
    return {success: true, data: newTime}
  }

  /**Stopt die Zeit des übergebenen Tickets
   * @param {Ticket} ticket */
  public async stopTicketTime(startedTime: TicketZeit,ticket?: Ticket, workstepId?: number){
    let activeTicket: Ticket = ticket ? ticket : this.general.getTicketValue().ticket
    startedTime.note = ""
    this.saveTime(startedTime)
    this.timeTickett.splice(this.timeTickett.findIndex(tt => tt.time.id == startedTime.id), 1)
    if(this.ticketSrv.runningExternalTime.find(tt => tt.time.id == startedTime.id))this.ticketSrv.runningExternalTime.splice(this.ticketSrv.runningExternalTime.findIndex(tt => tt.time.id == startedTime.id), 1)
    this.setActiveTimeFilter(this.activeTimeFilterValue)
    activeTicket.timeFrom = null
  }

  /**Gibt die Zeit des übergebenen Tickets zurück  
   * @param {Ticket} ticket
   * @returns {TicketZeit} 
   */
  public getTimeByTicket(workstepId: number): TicketZeit{
    const position = this.getTicketPosition(workstepId)
    if(position != null)return this.timeTickett[position].time
    return null
  }

  /** @returns {number} Gibt die position des aktuellen tickets in Zeiten Liste an oder null wenn nicht vorhanden*/
  public getTicketPosition(workstepId?: number):number{
    // const ticketValue: Ticket = ticket ? ticket : this.general.getTicketValue()
    // if(!ticketValue) return null
    const timeFromList = this.timeTickett.find(tt => tt.workspaceId == workstepId)
    if(timeFromList && timeFromList.workspaceId == workstepId){
      return this.timeTickett.indexOf(timeFromList)
    }
    return null
  }

  /**
   * speichern die übergebene Zeit in der Datenbank
   * @param {TicketZeit} ticketTime zeit die gespeichert werden soll 
   * @returns {Promise<void>}
   */
  public async saveTime(ticketTime: TicketZeit){
    const generatetTicketTime: HttpFunctionResult<TicketZeit> = await this.saveSrv.saveTicketTime(ticketTime, null, null, ticketTime.taskId)
    if(!generatetTicketTime.success) return
    generatetTicketTime.data.timeTo = new Date(generatetTicketTime.data.timeToAsISOString)
    generatetTicketTime.data.date = ticketTime.date
    this.ticketSrv.addTicketTime(generatetTicketTime.data)
  }

  /**
   * Löscht eine Zeit anhand der übergebenen ID.
   * @param id - Die ID der zu löschenden Zeit.
   * @param callback - Die Funktion, die das Ergebnis der Anfrage verarbeitet.
   * @returns Eine Promise, die das Ergebnis der Anfrage enthält.
   */
  public async deleteTime(id: number, callback: (result: HttpFunctionResult<any>)=> void){
    callback(await this.http.DELETE({path: `ticket/time/${id}`}))
  }

  /**
   * Gibt die Ids der Zeiten eines Arbeitsschrittes zurück
   * @param {number} workstepId id des Arbeitsschrittes 
   * @returns 
   */
  public getRunningTimeIdsByWorkstepId(workstepId: number): number[] | null{
    var ids: number[] = this.timeTickett.filter(tt => tt.workspaceId == workstepId).map(tt=> tt.time.id)
    return ids.length > 0 ? ids : null
  }

  /*ZEITEN FORMATIERUNG*/

  /**Beschreibung
  * @returns {string} Gibt ein übergebenes Datum formatiert als String zurück
  * @param {Date} date Datum was formatiert werden soll
  * @param {string} format Das format als welches es zurück gegeben werden soll
  * @example 
  * getFormatedDate(new Date(), "DD.MM.YYYY")
  */
  public getFormatedDate(date: Date, format: string): string{
    return dayjs(date).format(format).toString()
  }

    /**Beschreibung
  * @returns {string} Gibt die Different von 2 Daten an in ausgewählten Format
  * @param {Date} von Startdatum
  * @param {Date} bis Enddatum 
  * @example 
  * getDifference(new Date(), new Date(), "HH:mm.ss)
  */
  public getDifference(von: Date, bis: Date, format: string): string{

    //damit es mit 00:00:00 anfängt sonst steht am anfang 59:59:59 da
    const timeTo = dayjs(bis).isBefore(von) ? dayjs(von) : dayjs(bis)

    const hours: number = dayjs.duration(timeTo.diff(dayjs(von))).asSeconds() / 60 / 60 
    const restSeconds: number = Math.round((hours % 60) * 60 * 60)
    const hoursString: string = Math.floor(hours) > 0 ? `${ hours >= 10 || hours >= 100 ? Math.round(hours) : `0${Math.round(hours)}`}:` : "00:"

    return `${hoursString}${dayjs.utc(Math.round(restSeconds * 1000)).format("mm:ss")}`
  }
  
}